import React from 'react';
import ActionsUI from '../components/ActionsUI'; // Import ActionsUI component

const ActionsPage = () => (
  <div className="actions-page">
    <ActionsUI />
  </div>
);

export default ActionsPage;
